import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";

const UserGreeting = (props) => {
  const GreetingText = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: column;
    gap: 0.25em;

    p {
      font-size: small;
      font-weight: 600;
      margin: 0;
    }

    h3 {
      font-weight: 700;
      margin: 0;
    }
  `;

  return (
    <GreetingText>
      <p>Hey</p>
      <h3>{`${props.userInfo?.firstName} ${props.userInfo?.lastName}`}</h3>
    </GreetingText>
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
});

export default withRouter(connect(mapStateToProps, {})(UserGreeting));
